import Action from '../../Action'
import './styles/Discovery.css'
import { useState ,useEffect,useRef } from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter ,importFunction} from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const Discovery =({handleShowPopup,server,languaje,mode,importLoading,closeDiscoveryModal,setImportLoading})=>{
    const [file, setFile] = useState(null);
    const [disabled,setDisabled]=useState(true)
    const [msgError,setMsgError]=useState(true)
    const [boolError,setBoolError]=useState(false)
    const [response,setResponse]=useState([])
    const [logErrors,setLogErrors]=useState([])
    const [contElements,setConstElements]=useState(1)
    const [exportLoading,setExportLoading]=useState(false)
    const dataProxies=useFetch('zabbix/proxies','','','GET',server)
    const fileInputRef = useRef(null);
    const [ManttoData,setManttoData]=useState([{
        
          segment:"",
          proxyId:null,
    }])

    const handleDicoveryCount = () => {
        setManttoData([...ManttoData, { segment: "", proxyId: null }]);
    };

    // Función para manejar la importación
    const handleImport = async () => {
        setResponse([])
        setLogErrors([])
  
  
      setImportLoading(true);
  
      try {
          const response = await fetch(server.url + '/api/v1/cassia/hosts/discovery/', {
            method: 'POST',
            headers: {
              "Accept": "application/json",
             // 'Content-Type': 'application/json',
             'Content-Type': 'application/json',
               Authorization: `Bearer ${localStorage.getItem('access_token')}`,
             },
            body: JSON.stringify(ManttoData), // Enviamos el FormData con el archivo
          });
          if (response.ok) {
              const data1 = await response.json();

              if(data1.data.devices.length==0){
                  setResponse([{}])
              }else{
                  setResponse(data1.data.devices)
              }

              setLogErrors(data1.data.errors)
              // setLogErrors([{proxy:"prx-silao",proxy_ip:"172.18.37.62",errors:"[sudo] contraseña para zabix: sudo:arp-scan: orden no encontrada"},
              //     {proxy:"prx-silao",proxy_ip:"172.18.37.62",errors:"[sudo] contraseña para zabix: sudo:arp-scan: orden no encontrada"},
              //     {proxy:"prx-silao",proxy_ip:"172.18.37.62",errors:"[sudo] contraseña para zabix: sudo:arp-scan: orden no encontrada"},
              //     {proxy:"prx-silao",proxy_ip:"172.18.37.62",errors:"[sudo] contraseña para zabix: sudo:arp-scan: orden no encontrada"}
              // ])
              //     setManttoData([{

              //         segment:"",
              //         proxyId:null,
              //   }])
              let result=[]
              if(data1.data.devices.length!=0){
                  const keys = Object.keys(data1.data.devices[0]);
              const values = data1.data.devices.map(obj => Object.values(obj));
               result= [keys, ...values];
              }
              else{
                  result=[]
              }
              handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['discoverCorrect'])),capitalizeFirstLetter((lang[languaje]['msgImpor'])), true)
              setFileContent(result);
              setTableData(result);
              setDisabled(true)
              setImportLoading(false);
              setBoolError(false);
          } else {
            setImportLoading(false);
            setBoolError(true);
            handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            // setMsgError('Error en la importación');
            throw new Error('Error en la importación');
          }
      } catch (error) {
  setImportLoading(false);
  setBoolError(true);
//   setMsgError('Error al importar archivo');
  handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['importError']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
  console.error('Error al importar archivo:', error);
}
    };
    const [fileContent, setFileContent] = useState(null);
    const [tableData, setTableData] = useState([]);
    // useEffect(()=>{
    //     if(tableData.length!=0 && response.length==0){
    //         setDisabled(false)
    //     }else{
    //         setDisabled(true)
    //     }
    // },[tableData])
    // Función para leer el archivo
    const handleFileChange = (e) => {
      setResponse([])
      const file = e.target.files[0];
      setFile(file)
      importFunction(file,setFileContent,setTableData)
    };

    const handleChange = (index, event) => {
      const updatedManttoData = [...ManttoData];
      updatedManttoData[index].segment = event.target.value;
      validarSegmentos()
      setManttoData(updatedManttoData);
    };
    const changeOption=(option,index)=>{
        let attr=""
        if(option.filter=="Marcas"){
          attr="brand_id"
        }else if(option.filter=="hostModel"){
          attr="model_id"
        }else if(option.filter=="techDevices"){
          attr="device_id"
        }else if(option.filter=="proxy"){
          attr="proxy_id"
        }
        const updatedManttoData = [...ManttoData];
        updatedManttoData[index].proxyId =( option.value==0)?null: option.value;
        setManttoData(updatedManttoData);
    }
    const eliminarObjeto = (index) => {
        const updatedManttoData = ManttoData.filter((_, i) => i !== index);
        setManttoData(updatedManttoData);
        validarSegmentos()
    };
    // Renderizar la tabla
    const validarSegmentos = () => {
      const isValid = ManttoData.every((element) => element.segment && element.segment.trim() !== '');
      
      if (isValid) {
        setDisabled(false)
      } else {
          setDisabled(true)
      }
    };
    const validarCIDR = (cidr) => {
      const cidrRegex = /^(([0-9]{1,3}\.){3}[0-9]{1,3})\/([0-9]|[1-2][0-9]|3[0-2])$/;
      return cidrRegex.test(cidr);
    };
    const Exportar=()=>{
      
      let method='POST'
  // const body={
  //   "file_type": file_type,
  //   "hostids": poolRows
  // }
      setExportLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/hosts/discovery/download', {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(ManttoData),
           });
           if (response.ok) {
            // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
         const blob = await response.blob();
         const url = window.URL.createObjectURL(blob);
         const link = document.createElement('a');
         link.href = url;

         // Dependiendo del tipo de archivo, nombramos el archivo a descargar
         
         
           link.download = 'discovery.csv';
         

         document.body.appendChild(link);
         link.click();
         document.body.removeChild(link);
         // setAllSelected(false)
         // setPoolRows([])
         setExportLoading(false);
         handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])),'', true)

             
           } else {
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
             
          }
        };
    
        fetchDataPost();
        
  }
    const renderForms = () => { 
      // if (!tableData.length) return null;

      return (
          <div className="cont-body-multicard-modal-gs" style={{display:'block',border:'1px solid  var(--border-table-color)',overflow:'auto'}}>
                 {
                  ManttoData.map((element,index)=>(
                      <div className='contElementDiscovery'>
                          <div className='compactElementDiscovery'>
                              <div className='titleElementDiscovery'>
                              {'Elemento '+(index+1)}
                              {(index!=0)?<div className='deleteElementDiscovery' onClick={()=>eliminarObjeto(index)}>X</div>:''}
                              </div>
                              <div className='bodyElementDiscovery'>
                              <div className="form-GS-box" style={{height:'100%',width:'95%'}}> 
                 
                 <div className="user-box-GS"  style={{height:'50%'}}>
                                      <input required name="macaddress_a"  type="text" value={element.segment}
                                      onChange={(e) => handleChange(index, e)}  />
                                          <label className='label-GS  '>{'Segmento'}</label>
                                          {(element.segment!="" )?((validarCIDR(element.segment))?'':<span className='form-msg-error' style={{bottom:'0%'}}> {'Segmento no valido'}</span>):''}
                                      </div> 
                 <div className="user-box-GS "  style={{height:'50%'}}>
                                          {
                                              (dataProxies.loading)?'. . .':
                                              <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={'TODOS'}  opt_de={1} origen={'Admin'} data={dataProxies.data.data}   loading={dataProxies.loading}  titulo='proxy' selectFunction={changeOption} index={index}></SelectorAdmin>
                                          }
                                          <label className='label-GS'>{'Proxy'}</label>   
                                      </div>
                 </div>
                              </div>
                          </div>
                      </div>
             
                  ))
                 }
      </div>
      );
    };
    // Renderizar la tabla
    const renderTable = () => { 
     // if (!tableData.length) return null;

     return (
         <div className='contDiscoveryResponse'>
             <div className="cont-table-portafolio border-table" style={{height:'70%'}}>
       {
         (!tableData.length)?<div style={{height:'100%',width:'100%',display:'flex',justifyContent:'center',alignItems:'center',color:'var(--txt-color)'}}>Sin dispositivos encontrados</div>:
         <>
         <div className={"head-table-portafolio"+mode}>
       <div className="compact-head-table-portafolio">
       {tableData[0].map((header, index) => (
     //           <th key={index}>{header}</th
     (<div className="field-head-table-mantenimiento field-larger"  key={index} style={{width:'25%'}}>  {header} </div>)
             ))}
         </div>
       </div>
       <div className="body-table-portafolio" style={{overflowY:'auto'}}>
       {tableData.slice(1).map((row, rowIndex) => (
          <div
          className={"row-table-portafolio"+mode}
          key={rowIndex}
          style={{height:'40px'}}
        >
           {row.map((cell, cellIndex) => (
             (row.length>5)?
             
    <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
    {cell}
  </div>:
  <div className="field-body-table-mantenimiento field-larger" style={{width:'25%',fontSize:'var(--font-size-xSmall)'}} key={cellIndex}>
 {cell}
 </div>
               ))}
          
        </div>
     
           ))}
       </div>
         </>
       }
     </div>
             <div className='contLogErrorDiscovery'>
                 <div className='titleElementDiscovery' style={{background:'var(--red-alert)'}}>
                                     Log de errores
                 </div>
                 <div className='bodyElementDiscovery' style={{overflowY:'auto'}}>
                     {(logErrors.length==0)?'No se encontraron errores':
                     <div className='compactElementDiscovery' style={{border:'unset'}}>
                         
                     {
                         
                             logErrors.map((element,index)=>(
                                 <div className='rowLogErrorDiscoveri'>
                                     <div className='halfRowLogErrorDiscoveri'>
                                         <div >Error en proxy:&nbsp;&nbsp;</div><div style={{color:'red'}}>{element.proxy+"   "+element.proxy_ip}</div>
                                     </div>
                                     <div className='halfRowLogErrorDiscoveri'>
                                         {element.errors}
                                     </div>
                                 </div>
                             ))
                         }
                        
                     </div>
                     }
                 </div>
             </div>
         </div>
     );
   };
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {lang[languaje]['discovery'].toUpperCase()+' '+lang[languaje]['dispositivos'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' >
                
                    <div className="cont-import-GS-box" style={{height:'95%'}}> 
                        <div className='row-cont-input-file' style={{height:'10%'}}>
                            {
                                (importLoading)?<div className='txtCantData'>
                                {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])+'...'}
                        </div>:
                                <div className="file-input-container">
                                {(response.length==0 )?
                                <button className="custom-file-button" onClick={handleDicoveryCount}>
                                   {capitalizeFirstLetter(lang[languaje]['agregarElemento'])}
                                </button>:''}
      
                                
                            </div>
                            }
                        </div>
                        <div className='row-cont-input-table'  style={{height:'80%'}}>
                            {(response.length==0)?renderForms():renderTable() }
      
                        
                        </div>
                        <div className='row-cont-input-buttons'  style={{height:'10%'}}>
                        {(importLoading || exportLoading)?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%',width:'100%'}}><LoadSimple></LoadSimple></div>:
                        (
                        <>
                        <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(((response.length==0)?lang[languaje]['cancelar']:lang[languaje]['cerrar']))}  action={closeDiscoveryModal}/>
                        {(response.length==0 )?
                        <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['discovery'])}  action={handleImport}/>:

                        <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['exportar'])}  action={Exportar}/>
                        
                        }
                        {/* <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={handleImport}/> */}
                        </>
                        )
                        }
                        </div>           
                    </div>
                </div>
                </div>
        </div>
    )
}

export default Discovery